<template>
  <div>
    <div class="overall-navbar" id="overall-navbar">
      <admin-navbar />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>


<script>
import AdminNavbar from "../components/AdminNavbar";

export default {
  components: {
    AdminNavbar
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
</style>

